import api from "services/api";

// Get attendance records
export const getAttendanceRecords = async (params) => {
  return api.get("/v1/api/admin/attendance-records", {
    params,
  });
};

// Get team attendance records (Reporting Manager)
export const getTeamAttendanceRecords = async (params) => {
  return api.get("/v1/api/attendance/team-attendance", {
    params,
  });
};

// Get my attendance records (Employee)
export const getMyAttendanceRecords = async (params) => {
  return api.get("/v1/api/attendance/my-attendance-records", {
    params,
  });
};

// Clock In
export const clockIn = async (data = {}) => {
  const payload = {
    latitude: data.latitude || 0.0,
    longitude: data.longitude || 0.0,
    method: data.method || "web",
  };
  return api.post("/v1/api/attendance/clock-in", payload);
};

// Clock Out
export const clockOut = async (data = {}) => {
  const payload = {
    latitude: data.latitude || 0.0,
    longitude: data.longitude || 0.0,
    method: data.method || "web",
  };
  return api.post("/v1/api/attendance/clock-out", payload);
};

// Get Today Status
export const getTodayStatus = async () => {
  return api.get("/v1/api/attendance/today-status");
};

// Verify / Approve / Reject Attendance Record
export const verifyAttendanceRecord = async (id, data = {}) => {
  return api.put(`/v1/api/admin/attendance-records/${id}/verify`, data);
};

// Get monthly attendance report
export const getMonthlyAttendanceReport = async (params = {}) => {
  return api.get("/v1/api/admin/attendance/monthly-report", {
    params,
  });
};

// Confirm attendance for payroll by HR
export const confirmAttendance = async (data) => {
  return api.post("/v1/api/attendance/confirm-attendance", data);
};

// Submit regularization request
export const submitRegularization = async (data) => {
  return api.post("/v1/api/attendance/regularization", data);
};
// Get codes for legend
export const getLeaveCodes = async () => {
  return api.get("/v1/api/leave-codes");
};

// Get employee leave report
export const getEmployeeLeaveReport = async (params = {}) => {
  return api.get("/v1/api/admin/leave-logs", {
    params,
  });
};

// Delete attendance record
export const deleteAttendanceRecord = async (id) => {
  return api.delete(`/v1/api/admin/attendance-records/${id}`);
};
